import axios from "axios";
import { stripeConfig, ucEndpointsUrls } from "../../config/config";
import { addStripeProduct } from "../../utils/stripe";
import { getErrorMessageFromRequest } from "../../utils/utils";
import * as actionTypes from "./actionTypes";

export const gettingStartProjectProduct = () => {
  return {
    type: actionTypes.GETTING_START_PROJECT_PRODUCT
  };
};

export const getStartProjectProductFailed = message => {
  return {
    type: actionTypes.GET_START_PROJECT_PRODUCT_FAILED,
    payload: {
      message: message
    }
  };
};

export const getStartProjectProductSuccess = startProjectProduct => {
  return {
    type: actionTypes.GET_START_PROJECT_PRODUCT_SUCCESS,
    payload: {
      startProject: startProjectProduct
    }
  };
};

/**
 * Get Start Project product and populate Redux State.
 */
export const getStartProjectProduct = () => {
  return dispatch => {
    dispatch(gettingStartProjectProduct());
    axios
      .get(ucEndpointsUrls.stripeProducts, {
        params: {
          reference: stripeConfig.startProjectProductReference
        }
      })
      .then(res => {
        dispatch(getStartProjectProductSuccess(res.data[0]));
      })
      .catch(error => dispatch(getStartProjectProductFailed(getErrorMessageFromRequest(error))));
  };
};

export const setOpenPurchaseStartProjectModalStatus = isOpen => {
  return {
    type: actionTypes.SET_PURCHASE_START_PROJECT_MODAL,
    payload: {
      isOpen: isOpen
    }
  };
};

export const resetPurhcaseStartProjectModal = () => {
  return {
    type: actionTypes.RESET_PURCHASE_START_PROJECT_MODAL
  };
};

export const purchaseStartProjectFailedFailed = error => {
  return {
    type: actionTypes.PURCHASE_START_PROJECT_FAILED,
    payload: {
      message: error
    }
  };
};

/**
 * Redirects purchase start projects to Stripe Checkout.
 *
 * @param {Number} startProjectsQuantity       - Start projects quantity.
 */
export const purchaseStartProjectsCheckoutRedirect = startProjectsQuantity => {
  return (dispatch, getState) => {
    const userData = getState().users.userClaims;
    addStripeProduct(
      getState().products.startProject.stripeSkuId,
      startProjectsQuantity,
      userData.email,
      userData.userId
    ).catch(error => dispatch(purchaseStartProjectFailedFailed(getErrorMessageFromRequest(error))));
  };
};
